// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"2a6c4976","812":"d76c2c82"}[chunkId] + ".chunk.js";
};